<template>
	<div class="row mb-5">
		<div class="col-sm-12">
			<div class="row">
				<div class="col-sm-2 pr-0 pl-0">
					<label for="domain">Domain</label>
					<select id="domain" class="form-control" :disabled="loading" >
						<option :value="domain" selected>{{domain}}</option>
					</select>
				</div>
				<div class="col-sm-3 pl-0">
					<label for="from">Redirect from</label>
					<input  type="text" id="from" class="form-control" placeholder="/old/?$" v-model="redirect.from" :disabled="loading" />
				</div>
				<div class="col-sm-6">
					<div class="row">
						<div class="col-sm-2 pl-0 pr-0">
							<label for="type">Redirect to</label>
							<select class="form-control pl-1 pr-0" id="type" v-model="redirect.type" :disabled="loading" >
								<option value="http://">http://</option>
								<option value="https://">https://</option>
							</select>
						</div>
						<div class="col-sm-10 pl-0 pr-3">
							<label for="to"></label>
							<input type="text" id="to" :disabled="loading"  :style="{marginTop: '3px'}" class="form-control" placeholder="domain.com/newurl" v-model="redirect.to"/>
						</div>
					</div>
				</div>
				<div class="col-sm-1 pr-0 pl-0">
					<label for="code">Status code</label>
					<select class="form-control" id="code" v-model="redirect.code" :disabled="loading" >
						<option value="301">301</option>
						<option value="302">302</option>
					</select>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<button type="button" :disabled="loading" class="btn btn-outline-danger btn-round btn-sm pull-right mt-4 ml-4" @click="cancel">
						Cancel
					</button>
					<button type="button" :disabled="loading" class="btn btn-outline-primary btn-round btn-sm pull-right mt-4" @click="store">
						<div class="loader small_loader" v-if="loading"></div>
						<span v-else>
							<i class="fa fa-plus mr-2"></i> Add redirect
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import _ from "lodash";
	import validateMethods from "../../../mixins/validateMethods";

	function initialState (){
		return {
			redirect: {
				from: null,
				to: null,
				type: "https://",
				code: 301
			}
		}
	}

	export default {
		name: "RedirectCreate",
		props: ["domain", "loading"],
		mixins: [validateMethods],
		data: function () {
			return initialState();
		},
		watch: {
			loading: function (value) {
				if(value == false){
					Object.assign(this.$data, initialState());
				}
			}
		},
		methods: {
			store() {
				if(this.loading){
					return false;
				}
				let error = false;
				let message = "Please fill all fields.";
				if (!this.redirect.from || !this.redirect.to || !this.redirect.code) {
					error = true;
				}else if(this.validateUrl(this.redirect.to) || this.validateUrl(this.redirect.from)){
					error = true;
					message = "You need fill correct redirect";
				}

				if (error) {
					swal({
						title: "All Fields are Required!",
						html: message,
						type: "error"
					});
					return false;
				}
				this.redirect.domain = this.domain;
				this.redirect.uuid = _.uniqueId('redirect');
				this.$emit('store', this.redirect);
			},
			cancel(){
				Object.assign(this.$data, initialState());
			}
		}
	}
</script>